export default __webpack_public_path__ + "static/N0133-33fab4110af13773008e80ad9b7c0039.png";